module.exports = __webpack_public_path__ + "static/media/20b-06_ST-2020-455x526mm-oleo-sobre-madera.fdccdf70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/20b/20b-06_ST-2020-455x526mm-oleo-sobre-madera.jpg
// module id = 251
// module chunks = 0